import BreadCrumb from "components/Common/BreadCrumb";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Card,
    Col,
    Container,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
} from "reactstrap";
import { useQueryParams } from "use-query-params";
import TabTravelPlace from "./TravelPlace";
import TabTravelArticle from "./TravelArticle";
import TabTravelLog from "./TravelLog";


const NewsTravel = () => {
    const { t, i18n } = useTranslation();

    const [activeTab, setActiveTab] = useState("TRAVEL_PLACE");

    const [query, setQuery]: any = useQueryParams({});

    const tabChange = (tab: any) => {
        if (activeTab !== tab) {
            setQuery({}, "push");
            setActiveTab((_prev) => tab);
        }
    };

    useEffect(() => {
        document.title = `${t('News Travel')} - ${t('Boosting Content')} | PRESS Ai`;
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t("News Travel")} pageTitle={t("Boosting Content")} />
                    <Row>
                        <Col lg={12}>
                            <Card
                                id="ARTICLE"
                                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
                            >
                                <div
                                    style={{
                                        background: "#f3f6f9",
                                        borderTopLeftRadius: "0.6rem",
                                        borderTopRightRadius: "0.6rem",
                                    }}
                                >
                                    <div
                                        className="d-block"
                                        style={{
                                            background: "#f3f6f9",
                                            borderRadius: "0.6rem",
                                            width: "fit-content",
                                        }}
                                    >
                                        <Nav tabs className="nav nav-tabs nav-link-none-hover nav-justified">
                                            <NavItem style={{ minWidth: '140px' }}>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        background: `${activeTab === "TRAVEL_PLACE" ? "var(--vz-primary)" : "unset"}`,
                                                        color: `${activeTab === "TRAVEL_PLACE" ? "white" : "unset"}`,
                                                        borderTopRightRadius: 0
                                                    }}
                                                    onClick={() => tabChange("TRAVEL_PLACE")}
                                                >
                                                    {t("Travel Place")}
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={{ minWidth: '140px' }}>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        background: `${activeTab === "TRAVEL_ARTICLE" ? "var(--vz-primary)" : "unset"}`,
                                                        color: `${activeTab === "TRAVEL_ARTICLE" ? "white" : "unset"}`,
                                                        borderTopLeftRadius: 0,
                                                        borderTopRightRadius: 0,
                                                    }}
                                                    onClick={() => tabChange("TRAVEL_ARTICLE")}
                                                >
                                                    {t("Travel Article")}
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={{ minWidth: '110px' }}>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        background: `${activeTab === "TRAVEL_LOG" ? "var(--vz-primary)" : "unset"}`,
                                                        color: `${activeTab === "TRAVEL_LOG" ? "white" : "unset"}`,
                                                        borderTopLeftRadius: 0,
                                                        borderTopRightRadius: 0,
                                                    }}
                                                    onClick={() => tabChange("TRAVEL_LOG")}
                                                >
                                                    {t("Travel Log")}
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </div>
                                </div>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="TRAVEL_PLACE">
                                        {activeTab === "TRAVEL_PLACE" && (<TabTravelPlace />)}
                                    </TabPane>
                                    <TabPane tabId="TRAVEL_ARTICLE">
                                        {activeTab === "TRAVEL_ARTICLE" && (<TabTravelArticle />)}
                                    </TabPane>
                                    <TabPane tabId="TRAVEL_LOG">
                                        {activeTab === "TRAVEL_LOG" && (<TabTravelLog />)}
                                    </TabPane>
                                </TabContent>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default NewsTravel;
